import { render, staticRenderFns } from "./ModalGenerateUser.vue?vue&type=template&id=bf685298"
import script from "./ModalGenerateUser.vue?vue&type=script&lang=js"
export * from "./ModalGenerateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports